export default __webpack_public_path__ + "static/media/LogoInnomotics.d13d26c9.jpg";